export default __webpack_public_path__ + "static/models-3-9f0d04c7eb3b01f683f6b22920e168ca.mp4";